import React from 'react';
import { Payment } from './Payment';
import { LHDNBuyerDetailsForm } from './LHDNBuyerForm';


const paymentRoutes = [
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/:outletID/table/grid/:tableID/order/:orderID/payment`,
		},
		component: <Payment />,
	},
		{
		props: {
			exact: true,
			path: `/menu/outlet-app/:outletID/table/grid/:tableID/order/:orderID/payment/buyer-details`,
		},
		component: <LHDNBuyerDetailsForm />,
	},
];

export default paymentRoutes;
